import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonMenu, IonMenuToggle, IonNote, IonSelect, IonSelectOption, useIonAlert } from '@ionic/react';
import { cartOutline, cartSharp, cashOutline, cashSharp, contract, fileTrayFullOutline, fileTrayFullSharp, homeOutline, homeSharp, logOut, pencil, peopleOutline, peopleSharp, personOutline, personSharp, storefrontOutline, storefrontSharp, timeOutline, timeSharp } from 'ionicons/icons';
import { MouseEventHandler, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Organization, compareOrganizationWith } from '../../dto/organization';
import { Session } from '../../dto/session';
import { getCurrentOrganization, getSession, setCurrentOrganization } from '../../service/session';
import logoMM from '../../utils/img/logo-cliente.png';
import './Menu.css';

interface AppPage {
  url?: string;
  urlForm?: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
  onClick?: MouseEventHandler;
}

interface Param {
  logout: Function
}

const Menu: React.FC<Param> = ({ logout }) => {
  const location = useLocation()
  const [sessionData, setSessionData] = useState({} as Session)
  const [organization, setOrganization] = useState({} as Organization)
  const [presentAlert] = useIonAlert()
  const history = useHistory(); //chamado do hook
  const appPages: AppPage[] = [
    {
      title: 'Home',
      url: '/',
      iosIcon: homeOutline,
      mdIcon: homeSharp
    },
    {
      title: 'Unidades',
      url: '/page/unidades',
      iosIcon: storefrontOutline,
      mdIcon: storefrontSharp
    },
    {
      title: 'Períodos',
      url: '/page/periodos',
      iosIcon: timeOutline,
      mdIcon: timeSharp
    },
    {
      title: 'Mov. Produtos',
      url: '/page/mov-produtos',
      iosIcon: cartOutline,
      mdIcon: cartSharp
    },
    {
      title: 'Formas Pagamento',
      url: '/page/formas-pagamentos',
      iosIcon: cashOutline,
      mdIcon: cashSharp
    },
    {
      title: 'Operadores',
      url: '/page/operadores',
      iosIcon: personOutline,
      mdIcon: personSharp
    },
    {
      title: 'PDV',
      url: '/page/pdv',
      iosIcon: fileTrayFullOutline,
      mdIcon: fileTrayFullSharp
    },
    {
      title: 'Metas',
      url: '/page/meta',
      iosIcon: contract,
      mdIcon: contract
    }

  ]

  const profile = () => {
    history.push('/profile', sessionData);
  }

  if (sessionData.isAdmin) {
    appPages.push({
      title: 'Usuários',
      url: '/user/list',
      urlForm: '/user/form',
      iosIcon: personOutline,
      mdIcon: personSharp
    })

    appPages.push({
      title: 'Grupos',
      url: '/group/list',
      urlForm: '/group/form',
      iosIcon: peopleOutline,
      mdIcon: peopleSharp
    })
  }

  const logoutClick = () => {
    return presentAlert({
      header: "Sair",
      message: "<span> Deseja sair do aplicativo </span> ?",
      buttons: [
        {
          text: "Confirmar",
          role: "confirm",
          handler: async () => {
            logout()
          }
        },
        {
          text: "Cancelar",
          role: "cancel"
        }
      ]
    })
  }

  appPages.push({
    title: 'Sair',
    iosIcon: logOut,
    mdIcon: logOut,
    onClick: () => {
      logoutClick()
    }
  })

  useEffect(() => {
    const init = async () => {
      const sessionData: Session = await getSession()
      setSessionData(sessionData)

      const org: Organization = await getCurrentOrganization()
      setOrganization(org)
    }
    init()
  }, [])
  
  
  if (!organization) {
    return <></>
  }

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '100%' }}>
              <IonListHeader className='teste'>Sales Fast Analytics</IonListHeader>
            </div>
          </div>

          <div style={{cursor: 'pointer'}} onClick={() => {profile()}}> 
            <div style={{float: 'left', }}> 
              <IonNote>{sessionData.email}</IonNote>
            </div>
            <IonIcon icon={pencil} style={{color: '#666666', float: 'left', marginLeft: '4px'}}></IonIcon>
          </div>

          {sessionData && sessionData.organizations && organization && organization.id &&
            <IonSelect value={organization}
              compareWith={compareOrganizationWith}
              onIonChange={async (e) => { await setCurrentOrganization(e.detail.value); window.location.reload() }}
              style={{ width: '7em', marginBottom: '1em', marginTop: '1em', 
              marginLeft: 'auto', color: 'var(--color-combo-organization)', textAlign: 'right' }}>

              {sessionData.organizations ? sessionData.organizations.map((organization) => (
                <IonSelectOption key={organization.id} value={organization}>
                  {organization.name}
                </IonSelectOption>
              )) : <></>}
            </IonSelect>
          }


          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem onClick={appPage.onClick} 
                          className={(location.pathname === appPage.url || location.pathname === appPage.urlForm) 
                                && index !== (appPages.length - 1) ? 'selected' : ''} 
                          routerLink={appPage.url} 
                          routerDirection="root" 
                          lines="none" 
                          detail={false}>

                  <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                  <IonLabel style={{ marginLeft: '1em' }}>{appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}
          
        <div style={{width: '80%', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto'}}>
          <img style={{height: '4em', margin: 'auto'}} className='logo-menu' src={logoMM} alt='' />
        </div>
        </IonList>

      </IonContent>
    </IonMenu>
  );
};
export default Menu;
